import { ChangeDetectionStrategy, Component, inject, input, model, OnChanges, SimpleChanges } from '@angular/core';

import { NotificationTypeEnum } from '../../../models/enums/notification-type.enum';
import { NotificationModel } from '../../../models/notification.model';
import { DictionaryType } from '../../../models/types/dictionary.type';
import { NotificationsService } from '../../../services/notifications.service';

@Component({
    selector: 'sl-notifications-overlay',
    templateUrl: './notifications-overlay.component.html',
    styleUrls: ['./notifications-overlay.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotificationsOverlayComponent implements OnChanges {
    notifications = input.required<NotificationModel[]>();
    isLoading = model.required<boolean>();

    top5Notifications: NotificationModel[] = [];
    readonly notificationTypeIcons: DictionaryType<string> = {
        [NotificationTypeEnum.Alert]: 'notifications',
        [NotificationTypeEnum.Info]: 'info',
        [NotificationTypeEnum.Warning]: 'report_problem',
        [NotificationTypeEnum.Error]: 'highlight_off'
    };

    private readonly notificationsService = inject(NotificationsService);

    ngOnChanges(changes: SimpleChanges): void {
        const notifications = changes['notifications']?.currentValue ?? [];
        this.top5Notifications = notifications.slice(0, 5);
    }

    confirmNotification(notification: NotificationModel): void {
        const index = this.notifications().indexOf(notification);

        if (index < 0) {
            return;
        }

        this.isLoading.set(true);
        this.notificationsService.markAsConfirmed(notification.id).subscribe(() => {
            this.notifications().splice(index, 1);
            this.isLoading.set(false);
        });
    }

    closeOverlay(): void {
        this.notificationsService.toggleOverlay(false);
    }
}
